// shared/role.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CryptoJsService } from '../services/crypto-js.service';

export const roleGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const localStorage = inject(CryptoJsService);
  const permissionLevel = localStorage.getItem('permissionLevel'); // 'sales' | 'admin' | null
  console.log('permissionLevel', permissionLevel);
  if (!permissionLevel) {
    router.navigate(['/login']);
    return false;
  }

  const allowedRoles = route.data['roles'] as string[] | undefined;

  if (!allowedRoles || allowedRoles.length === 0) {
    return true;
  }

  if (allowedRoles.includes(permissionLevel)) {
    return true;
  }
  router.navigate(['/no-autorizado']);
  return false;
};
